'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { composeButtonClasses } from '@components/common/Anchor/anchorButtonStyles';

/**
 * Renders a translated link that opens the Consent/Cookie Preferences modal.
 */
export const ConsentLink: React.FC = () => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      window.dispatchEvent(new CustomEvent('open-consent-modal'));
    } catch {
      // no-op
    }
  };
  const linkLikeClasses = composeButtonClasses(
    'primary',
    'md',
    'text',
    'normal',
    '',
  );

  return (
    <button
      type="button"
      className={linkLikeClasses}
      onClick={handleClick}
      data-test-id="consent-link"
      aria-haspopup="dialog"
    >
      {t('legal.confidentiality.modify_consent')}
    </button>
  );
};
